import React, { useCallback, useContext } from 'react';
import { useLocation } from '@thd-olt-component-react/router';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import {
  useDataModel, params, string, number, shape, arrayOf, extend
} from '@thd-nucleus/data-sources';

import { ProductResultsSearchMethodsPLP } from '../utils/product-results-search-methods-PLP';
import { ResultsFilterAndSortDrawer } from '../components/ResultsFilterAndSortDrawer';

export const ResultsFilterAndSortDrawerComposable = () => {
  const { onSortChangePLP, onDimensionsChangePLP } = ProductResultsSearchMethodsPLP();
  // viewPrimaryFilters flag is always true it is feature switch 
  const viewPrimaryFilters = true;
  const viewAllFilterButton = useConfigService('fs-prop:isViewAllFilterButtonEnabled');
  // it will be always true because it it feature switch
  const isGetItFastOnPlp = true;
  const { pathname, search } = useLocation();
  const path = `${pathname}${search}`;
  const { customContext, channel } = useContext(ExperienceContext);
  const { variables = {} } = customContext || {};
  const defaultOptions = {
    variables,
    ssr: true,
    skip: !variables?.keyword && !variables?.navParam
  };
  const { data = {}, loading, variables: dataModelVariables, ...rest } = useDataModel('searchModel', defaultOptions);
  const { metadata } = data?.searchModel || {};
  const { contentType } = metadata || {};
  const isCategory = contentType === 'categorypage';

  const { isConsumerApp, pageType } = customContext || {};
  
  // Prepare query variables and page context for the component
  const queryVariables = dataModelVariables || variables;
  const pageContext = { pageType };

  const onDimensionsChangeInternal = useCallback(({ refinement }) => {
    return onDimensionsChangePLP({
      refinement,
      viewPrimaryFilters,
    });
  }, [viewPrimaryFilters, onDimensionsChangePLP]);

  const handleSortChange = useCallback((sortParams) => {
    onSortChangePLP({ ...sortParams, path });
  }, [path, onSortChangePLP]);

  if (isCategory && !viewPrimaryFilters) return null;

  return (
    <>
      {channel === 'mobile' ? (
        <ResultsFilterAndSortDrawer
          enableMultiStore={!isConsumerApp}
          onDimensionsChange={onDimensionsChangeInternal}
          onSortChange={handleSortChange}
          stickyOffset={59}
          isGetItFastOnPlp
          searchModelData={data}
          loading={loading}
          queryVariables={queryVariables}
          pageContext={pageContext}
          disableStickyFilter
          excludePickUpToday
        />
      ) : (
        <ResultsFilterAndSortDrawer
          onSortChange={handleSortChange}
          onDimensionsChange={onDimensionsChangeInternal}
          disableStickyFilter
          excludePickUpToday
          hideViewAll={!viewAllFilterButton}
          searchModelData={data}
          loading={loading}
          queryVariables={queryVariables}
          pageContext={pageContext}
        />
      )}
    </>
  );
};

ResultsFilterAndSortDrawerComposable.displayName = 'ResultsFilterAndSortDrawerComposable';

ResultsFilterAndSortDrawerComposable.dataModel = extend({
  searchModel: params({ keyword: string(), navParam: string(), storeId: string() }).shape({
    metadata: shape({
      contentType: string(),
      h1Tag: string()
    })
  })
}, ResultsFilterAndSortDrawer?.dataModel || {});
